<template>
  <div class="user">
    <div class="user__header">
      <UserInfo
        canEdit
        size="lg"
        :userPhoto="userInfo.miniPhoto"
        :username="userInfo.name"
        :desc="userInfo.desc"
      />

      <div
        class="user-block"
        @click="onBlock"
      >
        <span class="user-block__text">
          {{ userInfo.isBlocked ? 'Разблокировать' : 'Заблокировать аккаунт' }}
        </span>
        <BaseIcon icon="stop" class="user-block__icon" />
      </div>
    </div>

    <AppMenu
      v-model="activeMenuItem"
      :items="menuItems"
      class="user__menu"
    />

    <KeepAlive>
      <component
        :is="componentName"
        class="user__filling"
      />
    </KeepAlive>
  </div>
</template>

<script>

import UserInfo from '@/components/UserInfo'
import AppMenu from '@/components/AppMenu'
import BaseIcon from '@/components/Base/BaseIcon'
import AppInformation from './components/AppInformation'
import AppFriends from './components/AppFriends'
import AppEvents from './components/AppEvents'
import AppTeam from './components/AppTeam'

export default {
  name: 'user',
  components: {
    BaseIcon,
    AppMenu,
    UserInfo,
    AppInformation,
    AppFriends,
    AppEvents,
    AppTeam
  },
  data () {
    return {
      userInfo: {
        name: '',
        desc: '',
        miniPhoto: '',
        isBlocked: false
      },
      menuItems: [
        { value: 'information', label: 'Инфо', component: 'AppInformation' },
        { value: 'friends', label: 'Друзья', component: 'AppFriends' },
        { value: 'events', label: 'События', component: 'AppEvents' },
        { value: 'teams', label: 'Команды', component: 'AppTeam' }
      ],
      activeMenuItem: this.$route.query.tab ?? 'information'
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    }
  },
  watch: {
    activeMenuItem (newValue) {
      this.$router.push({
        path: this.$route.fullPath,
        query: { tab: newValue }
      })
    }
  },
  created () {
    this.fetchUserData()
  },
  methods: {
    async fetchUserData () {
      try {
        const id = this.$route.params.id
        const { data } = await this.$api.user.user(id)
        const name = data?.name ?? ''
        const surname = data?.surname ?? ''

        this.userInfo.name = `${name} ${surname}`
        this.userInfo.miniPhoto = data?.photo?.url ?? ''
        this.userInfo.isBlocked = data.isBlock
      } catch (e) {
        console.log(e)
      }
    },
    async onBlock () {
      try {
        if (this.userInfo.isBlocked) {
          await this.$api.user.unblock(this.$route.params.id)
        } else {
          await this.$api.user.block(this.$route.params.id)
        }

        await this.fetchUserData()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__menu {
    margin-top: 30px;
  }

  &__filling {
    margin-top: 30px;
  }

  &-block {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &__text {}
    &__icon {
      width: 14px;
      margin-left: 12px;
    }
  }
}
</style>
